export const cellProps = {
  bg: 'white',
  m: 1,
  color: 'black',
}

export const selectedCellProps = {
  bg: 'primary.base',
  m: 1,
  color: 'white',
}

export const CENTER_COL_INDEX = 40
export const CENTER_ROW_INDEX = 12
export const CENTER_INDEX = 44
